/**
 *
 * Asynchronously loads the component for OverlayThumb
 *
 */

import { lazyLoad } from 'src/utils/loadable';

export const OverlayThumb = lazyLoad(
  () => import('./index'),
  (module: { OverlayThumb: any }): any =>
    module.OverlayThumb,
);
